var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 8.33659C11.8383 8.33659 13.3307 6.8442 13.3307 5.00326C13.3307 3.16231 11.8383 1.66992 9.9974 1.66992C8.15645 1.66992 6.66406 3.16231 6.66406 5.00326C6.66406 6.8442 8.15645 8.33659 9.9974 8.33659Z",
    stroke: "#0699CE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.3301C17.5 14.188 14.1421 10.8301 10 10.8301C5.85787 10.8301 2.5 14.188 2.5 18.3301",
    stroke: "#0699CE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 18.3301L11.6693 16.2467L10.0026 10.8301L8.33594 16.2467L10.0026 18.3301Z",
    stroke: "#0699CE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.f1bd41622b6a5d0a900dfe85f0ff16fa.svg";
export { ForwardRef as ReactComponent };